import { Injectable } from '@angular/core';
import { S3ProductPublicService } from './s3-product-public.service';

@Injectable({ providedIn: 'root' })
export class S3SprPublicService extends S3ProductPublicService {
  protected buildProbeImageUrl(month: string): string {
    return `${this.bucketBaseUrl}/${this.monthPrefix}${month}/persist/persistencia_brasil_${month}.png`;
  }
}
